/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SignageMode {
    Default = 0,
    Media = 1,
    TrainingRoom = 2,
}
